import './mobile-show-more.scss';

( function() {
	'use strict';

	const openButton = document.querySelector( '.js-mobileShowMore' );
	const closeButtons = document.querySelectorAll( '.js-close-mobileShowMore' );
	const popup = document.querySelector( '.m-mobileShowMore' );
	const overlay = document.querySelector( '.m-mobileShowMoreOverlay' );

	if ( ! openButton || ! closeButtons.length || ! popup ) {
		return;
	}

	let activeElementBeforeOpen = null;

	const focusableSelectors = [
		'a[href]',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'[tabindex]:not([tabindex="-1"])'
	].join( ', ' );

	const getFocusableElements = () => {
		return Array.from( popup.querySelectorAll( focusableSelectors ) );
	};

	const getFirstFocusableElement = () => {
		const elements = getFocusableElements();
		return elements[ 0 ] || null;
	};

	const openPopup = () => {
		activeElementBeforeOpen = document.activeElement;
		popup.classList.add( '-isOpen' );
		if ( overlay ) {
			overlay.classList.add( '-isOpen' );
		}
		openButton.setAttribute( 'aria-expanded', 'true' );
		popup.setAttribute( 'role', 'dialog' );
		popup.setAttribute( 'aria-modal', 'true' );
		popup.id = 'mobile-show-more-popup';
		document.body.style.overflow = 'hidden';

		closeButtons.forEach( button => {
			button.removeAttribute( 'tabindex' );
		} );

		setTimeout( () => {
			const firstFocusable = getFirstFocusableElement();
			if ( firstFocusable ) {
				firstFocusable.focus();
			}
		}, 10 );
	};

	const closePopup = () => {
		popup.classList.remove( '-isOpen' );
		if ( overlay ) {
			overlay.classList.remove( '-isOpen' );
		}
		openButton.setAttribute( 'aria-expanded', 'false' );
		popup.removeAttribute( 'role' );
		popup.removeAttribute( 'aria-modal' );
		document.body.style.overflow = '';

		closeButtons.forEach( button => {
			button.setAttribute( 'tabindex', '-1' );
		} );

		if ( activeElementBeforeOpen ) {
			activeElementBeforeOpen.focus();
			activeElementBeforeOpen = null;
		}
	};

	const handleKeyDown = ( e ) => {
		if ( ! popup.classList.contains( '-isOpen' ) ) {
			return;
		}

		if ( 'Escape' === e.key ) {
			e.preventDefault();
			closePopup();
			return;
		}

		if ( 'Tab' === e.key ) {
			const elements = getFocusableElements();
			if ( 0 === elements.length ) {
				e.preventDefault();
				return;
			}

			const firstElement = elements[ 0 ];
			const lastElement = elements[ elements.length - 1 ];

			if ( e.shiftKey ) {
				if ( document.activeElement === firstElement ) {
					e.preventDefault();
					lastElement.focus();
				}
			} else {
				if ( document.activeElement === lastElement ) {
					e.preventDefault();
					firstElement.focus();
				}
			}
		}
	};

	openButton.addEventListener( 'click', openPopup );
	closeButtons.forEach( button => {
		button.addEventListener( 'click', closePopup );
	} );
	if ( overlay ) {
		overlay.addEventListener( 'click', closePopup );
	}
	document.addEventListener( 'keydown', handleKeyDown );

} )();

